import {
  FaAppleAlt,
  FaDumbbell,
  FaFire,
  FaHeartbeat,
  FaHome,
  FaLeaf,
  FaRunning,
  FaSeedling,
  FaSpa,
  FaUtensils,
  FaWeight,
} from 'react-icons/fa';

/** Known specialty icon codes (Admin Meal Plan Masters → Icon code). */
export const SPECIALTY_ICON_BY_CODE = {
  home: FaHome,
  dumbbell: FaDumbbell,
  heartbeat: FaHeartbeat,
  weight: FaWeight,
  leaf: FaLeaf,
  utensils: FaUtensils,
  apple: FaAppleAlt,
  running: FaRunning,
  spa: FaSpa,
  fire: FaFire,
  seedling: FaSeedling,
  general: FaHome,
  gym: FaDumbbell,
  diabetic: FaHeartbeat,
  weightloss: FaWeight,
};

export function resolveSpecialtyIcon(iconCode, fallbackCode) {
  const key = String(iconCode || fallbackCode || '').trim().toLowerCase();
  return SPECIALTY_ICON_BY_CODE[key] || FaHome;
}
